import { styled } from 'styled-components';

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
`;
